import React, { useEffect, useState } from 'react'
import { v3_ncr, v3_ncr_Status_Update } from '../../../actions/v3/ncr'
import moment from 'moment'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../../constant'
import { toast } from 'react-toastify'

const Index = ({ shipId, filterPayload, setStatusCount, setData }) => {

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [localData, setLocalData] = useState(null)
    const [ncrId, setNcrId] = useState('')
    const [refresh, setRefresh] = useState(false);
    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Open', 'Close'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
    })

    const encodeFilterPayload = (payload) => {
        try {
            const json = JSON.stringify(payload);
            if (!json) return '';

            if (typeof TextEncoder !== 'undefined') {
                const bytes = new TextEncoder().encode(json);
                let binary = '';
                bytes.forEach((b) => {
                    binary += String.fromCharCode(b);
                });
                return btoa(binary);
            }

            // Fallback for older browsers.
            return btoa(unescape(encodeURIComponent(json)));
        } catch (error) {
            console.error('Failed to encode filter payload:', error);
            return '';
        }
    };

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };
    const handleStatusUpdateSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            remark: statusState.remarks.value,
            status: statusState.status.value,
            ncrId: ncrId
        };

        v3_ncr_Status_Update(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                if (modal) modal.hide();
            }
        })
    };
    useEffect(() => {
        v3_ncr(page, limit, shipId, encodeFilterPayload(filterPayload)).then((res) => {
            if (res.status) {
                setLocalData(res.result)
                if (setData) {
                    setData(res.result);
                }
                setStatusCount(res.result.statusCountMap)

            }
        })
    }, [shipId, page, limit, refresh, filterPayload])


    return (
        <div className="appraisal-report-table-responsive">
            <table className="plan-approval-table">
                <thead>
                    <tr>
                        <th>Refrence No.</th>
                        <th>Subject</th>
                        <th>Created By</th>
                        <th>Date Created</th>
                        <th>Status</th>
                        <th>Comments</th>
                    </tr>
                </thead>
                <tbody>

                    {localData ? (
                        localData.ncr.length > 0 ? (
                            localData.ncr.map((item, index) => {

                                return (
                                    <tr key={item.ID || index}>
                                        <td>

                                            <Link to={{
                                                pathname: constant.Authedcomponent.ncrDetail.url,
                                                state: {
                                                    ncrId: item.ID,
                                                    shipId: shipId
                                                }
                                            }}>
                                                <p className="s1">  {item.NCR_NUMBER}</p>
                                                {/*<p className="s1">  {item.STATUS}</p>*/}


                                            </Link>
                                        </td>
                                        <td>
                                            
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.ncrDetail.url,
                                                        state: {
                                                            ncrId: item.ID,
                                                            shipId: shipId,
                                                        },
                                                    }}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    <p className="s1" style={{ margin: 0 }}>{item.SUBJECT}</p>
                                                    <p>Reference Number
                                                        : {item.NCR_NUMBER}</p>
                                                </Link>

                                                {/* <i
                                                    className="bx bx-edit"
                                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                                    onClick={() => {
                                                        setNcrId(item.ID);
                                                    }}
                                                    data-bs-toggle="modal"
                                                    data-bs-target={`#statusUpdateModal`}
                                                />

                                                <div
                                                    className="modal fade"
                                                    id={`statusUpdateModal`}
                                                    data-bs-backdrop="static"
                                                    data-bs-keyboard="false"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby="statusUpdateModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="statusUpdateModalLabel">
                                                                    Update Status
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-3">
                                                                        <label>Status <span >*</span></label>
                                                                        <select
                                                                            name={'status'}
                                                                            value={statusState['status'].value}
                                                                            onChange={handleStatusStateChange}
                                                                            className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                                        >
                                                                            <option value=''>Select Status</option>
                                                                            {statusState.status.options.map((status) => {
                                                                                return (
                                                                                    <option value={status}>{status}</option>

                                                                                )
                                                                            })}
                                                                        </select>
                                                                        {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                                    </div>

                                                                    <div className="col-md-12 mb-3">
                                                                        <label>Remarks</label>
                                                                        <textarea
                                                                            row='2'
                                                                            name={'remarks'}
                                                                            placeholder='Enter Remarks'
                                                                            value={statusState['remarks'].value}
                                                                            onChange={handleStatusStateChange}
                                                                            className={`form-control ${statusState['remarks'].error ? 'is-invalid' : ''}`}
                                                                        />
                                                                        {statusState['remarks'].error && <div className="invalid-feedback">{statusState['remarks'].error}</div>}
                                                                    </div>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <button type="submit" className="btn btn-success me-2"
                                                                        onClick={() => {
                                                                            handleStatusUpdateSubmit()

                                                                        }}
                                                                    >Submit</button>
                                                                    <button className="btn btn-danger text-white" onClick={() => {
                                                                        const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                                                                        if (modal) modal.hide();
                                                                    }}>Cancel</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </td>
                                        <td> <p className="s1">{item.CREATED_BY_NAME}</p></td>
                                        <td> <p className="s1">{moment(item.CREATED_ON).format('MMM DD YYYY')}</p></td>
                                        <td> <p className="s1">{item.STATUS}</p></td>
                                        <td><p><i className='fa fa-comment' /> 0</p>
                                            <p>0 Draft  0 Accepted  0 Closed</p>
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center text-muted">
                                    No NCR records found
                                </td>
                            </tr>
                        )
                    ) : (
                        ''
                    )}

                </tbody>
            </table>

        </div>




    )
}

export default Index
